"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_redux_1 = require("react-redux");
const react_1 = __importStar(require("react"));
const SweetAlert_1 = require("../base/SweetAlert");
const redux_1 = require("redux");
const hide_1 = require("../actions/hide");
const constants_1 = require("../constants");
const react_router_1 = require("react-router");
const ReducerRegistry_1 = __importDefault(require("../../redux/ReducerRegistry"));
const reducers_1 = require("../reducers");
ReducerRegistry_1.default.register(constants_1.REDUCER_SWEET_ALERT_NAME, reducers_1.reducerSweetAlert);
const SweetAlert = (_a) => {
    var { show, hide, hideComplete, content } = _a, props = __rest(_a, ["show", "hide", "hideComplete", "content"]);
    const history = (0, react_router_1.useHistory)();
    (0, react_1.useEffect)(() => {
        const historyUnListen = history.listen((location, historyAction) => {
            if (historyAction === 'REPLACE') {
                return;
            }
            hide();
        });
        return () => {
            historyUnListen();
        };
    }, []);
    const renderContent = () => {
        if (!content) {
            return null;
        }
        return content();
    };
    return (react_1.default.createElement(SweetAlert_1.SweetAlert, Object.assign({ show: show, onClose: () => {
            hide();
        }, onTransitionExited: () => {
            hideComplete();
        } }, props), renderContent()));
};
const mapStateToProps = (state) => (Object.assign({}, state[constants_1.REDUCER_SWEET_ALERT_NAME]));
const mapDispatchToProps = (dispatch) => (0, redux_1.bindActionCreators)({
    hide: hide_1.sweetAlertHide,
    hideComplete: hide_1.sweetAlertHideComplete,
}, dispatch);
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(SweetAlert);
